import { useMemo } from "react";
import ReferralViewModel from "view-model/Referrals/ReferralViewModel";

const useReferral = () => {
    const referralViewModel = useMemo(() => new ReferralViewModel(), [])
    return { referralViewModel };
};

export default useReferral;
